import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Componente que restablece la posición del scroll al inicio
 * cuando se navega entre rutas en la aplicación.
 *
 * Este componente no renderiza nada visible, solo ejecuta la lógica
 * de scroll cuando cambia la ruta (pathname).
 *
 * @returns {null} No renderiza nada en el DOM
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Si hay un hash en la URL (ej: /pagina#seccion), permitir el scroll natural
    if (hash) {
      // Pequeño retraso para asegurar que el elemento con ese ID esté disponible
      setTimeout(() => {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);
      return;
    }

    // Si no hay hash, hacer scroll al inicio de la página
    try {
      // Opciones para soportar más navegadores
      if ("scrollTo" in window) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "instant", // Usar 'instant' en lugar de 'auto' para compatibilidad
        });
      } else {
        // Fallback para navegadores antiguos
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0; // Para Safari
      }

      // Opcional: mover foco al contenido principal para mejorar accesibilidad
      const mainContent = document.getElementById("main-content");
      if (mainContent) {
        mainContent.focus({ preventScroll: true });
      }
    } catch (error) {
      console.error("Error al restablecer la posición de scroll:", error);
    }
  }, [pathname, hash]); // Se ejecuta cuando cambia la ruta o el hash

  return null; // Este componente no renderiza nada
};

export default ScrollToTop;
